import { render, staticRenderFns } from "./BreadcrumbPartial.vue?vue&type=template&id=5943d55c&scoped=true&"
import script from "./BreadcrumbPartial.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbPartial.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbPartial.vue?vue&type=style&index=0&id=5943d55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5943d55c",
  null
  
)

export default component.exports